import { Routes } from '@angular/router';
import { ADMIN_ROUTES } from './routes/admin.routes';
import { DASHBOARD_ROUTES } from './routes/dashboard.routes';
import { DOCUMENTS_ROUTES } from './routes/documents.routes';
import { EXTERNES_ROUTES } from './routes/externes.routes';
import { FAMILIES_ROUTES } from './routes/families.routes';
import { FAMILLE_ROUTES } from './routes/famille.routes';
import { MEDIAS_ROUTES } from './routes/medias.routes';
import { NOTICES_ROUTES } from './routes/notices.routes';
import { PERSONNEL_ROUTES } from './routes/personnel.routes';
import { PLANNING_ROUTES } from './routes/planning.routes';
import { PRATICIEN_ROUTES } from './routes/praticien.routes';
import { RAPPORTS_ACTIVITE_ROUTES } from './routes/rapports-activite.routes';
import { BILANS_ANNUELS_ROUTES } from './routes/bilans-annuels.routes';
import { REMOTE_ROUTES } from './routes/remote.routes';
import { RESIDENTS_ROUTES } from './routes/residents.routes';
import { RGPD_ROUTES } from './routes/rgpd.routes';
import { STICKS_ROUTES } from './routes/sticks.routes';
import { TECH_ROUTES } from './routes/tech.routes';

export const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  // Callbacks OIDC — AVANT loadChildren `auth` (sinon le ticket peut être perdu via **)
  {
    path: 'auth/sso/callback',
    loadComponent: () =>
      import('./features/auth/sso-callback/sso-callback.component').then(
        (m) => m.SsoCallbackComponent
      ),
  },
  {
    path: 'auth/social/callback',
    loadComponent: () =>
      import('./features/auth/social-callback/social-callback.component').then(
        (m) => m.SocialCallbackComponent
      ),
  },
  {
    path: 'social/callback',
    loadComponent: () =>
      import('./features/auth/social-callback/social-callback.component').then(
        (m) => m.SocialCallbackComponent
      ),
  },
  {
    path: 'auth',
    loadChildren: () => import('./features/auth/auth.routes').then(m => m.AUTH_ROUTES),
  },
  {
    path: 'activation-compte',
    loadComponent: () =>
      import('./features/auth/activation-compte/activation-compte.component').then(
        (m) => m.ActivationCompteComponent
      ),
  },
  ...DASHBOARD_ROUTES,
  ...TECH_ROUTES,
  ...PRATICIEN_ROUTES,
  ...ADMIN_ROUTES,
  ...NOTICES_ROUTES,
  ...RESIDENTS_ROUTES,
  ...STICKS_ROUTES,
  ...PERSONNEL_ROUTES,
  ...EXTERNES_ROUTES,
  ...FAMILIES_ROUTES,
  ...DOCUMENTS_ROUTES,
  ...RGPD_ROUTES,
  ...MEDIAS_ROUTES,
  ...REMOTE_ROUTES,
  ...FAMILLE_ROUTES,
  ...PLANNING_ROUTES,
  ...RAPPORTS_ACTIVITE_ROUTES,
  ...BILANS_ANNUELS_ROUTES,
  { path: '**', redirectTo: '/auth/login' },
];
